import AddToBasketBtn from "components/AddToBasketBtn";
import GetIcon from "components/GetIcon";
import Quantity from "components/Quantity";
import Title from "components/Title";
import { BasketContext } from "context/BasketContext";
import useMakeRequest from "hooks/useMakeRequest";
import { useContext } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import styles from "styles/Detail.module.scss";
import config from "../config";

const Detail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  let id = slug.split("-");
  id = id[id.length - 1];

  const result = useMakeRequest(`${config.API_BASE_URL}/products/${id}`);
  const { basketItems } = useContext(BasketContext);

  const setStars = (rate) => {
    let elements = [];
    let controlNumber = 0;
    for (let i = 1; i <= 5; i++) {
      if (i <= parseInt(rate)) {
        controlNumber = parseInt(rate) - i;
        elements.push(<GetIcon icon="BsFillStarFill" color="#F0A500" size={20} key={i} />);
      } else if (controlNumber === 0) {
        controlNumber = 1;
        elements.push(<GetIcon icon="BsStarHalf" color="#F0A500" size={20} key={i} />);
      } else {
        elements.push(<GetIcon icon="BsStar" color="#F0A500" size={20} key={i} />);
      }
    }
    return elements;
  };

  const getItemFromBasket = (data) => {
    let filter = basketItems.length > 0 && basketItems.filter((item) => item.id === data.id)[0];
    if (filter) {
      return filter;
    } else {
      return data;
    }
  };

  const formattedPrice = parseFloat(result.data?.price || 0).toFixed(2);

  return (
      <section className={styles.detail}>
        {!result.data ? (
            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
              <Title txt="Loading..." size={25} transform="uppercase" />
            </div>
        ) : (
            <div className={styles.content}>
              <button className={styles.backButton} onClick={() => navigate(-1)}>
                Volver
              </button>
              <div className={styles.top}>
                <div className={styles.img}>
                  <img src={result.data.image_url} alt={result.data.title} />
                </div>
                <div className={styles.info}>
                  <div className={styles.title}>
                    <Title txt={result.data.title} transform="uppercase" size={22} />
                  </div>
                  <div className={styles.category}>
                    <Link to={`/category/${result.data.category}`} style={{ color: "#0E3EDA" }}>
                      {result.data.category}
                    </Link>
                  </div>
                  <div className={styles.rating}>
                    <div className={styles.stars}>{setStars(result.data.rate)}</div>
                  </div>
                  <div className={styles.price}>
                    <p>{formattedPrice} <small>₡</small></p>
                  </div>
                  <div className={styles.availableQuantity}>
                    <p>Cantidad en inventario: {result.data.quantity}</p>
                  </div>
                  <div className={styles.addToBasketAndQuantity}>
                    <div className={styles.quantityBox}>
                      <Quantity data={getItemFromBasket(result.data)} max={result.data.quantity}/>
                    </div>
                    <AddToBasketBtn data={result.data} maxQuantity={result.data.quantity}/>
                  </div>
                </div>
              </div>
              <div className={styles.bottom}>
                <Title txt="Descripcion" size={20} transform="capitalize"/>
                <p className={styles.desc}>{result.data.description}</p>
              </div>
            </div>
        )}
      </section>
  );
};

export default Detail;